import { IconChevronRight16, UIHeading4, UIText2 } from '@cian/ui-kit';
import { Link } from '../Link';
import styles from './MyHouseBanner.css';
import image from './assets/image.svg';
import { NBSP } from 'shared/constants/symbols';
import { FC } from 'react';

interface IMyHouseBannerProps {
  link: string;
  onClick: VoidFunction;
}

export const MyHouseBanner: FC<IMyHouseBannerProps> = ({ link, onClick }) => {
  return (
    <Link href={link} dataName="MyHouseBanner" target="_blank" onClick={onClick}>
      <div className={styles['container']}>
        <img src={image} />
        <div className={styles['body']}>
          <div className={styles['text']}>
            <UIHeading4>
              Живёте здесь? Добавьте адрес в{NBSP}Мой{NBSP}дом
            </UIHeading4>
            <UIText2 color="gray60_100">Сможете следить, как меняется цена вашей квартиры</UIText2>
          </div>
          <IconChevronRight16 color="gray60_100" />
        </div>
      </div>
    </Link>
  );
};
